import { FormTemplate } from "components/modal/templates";
import { ymEvent } from "helpers/system";
import React from "react";
import { applyOrganizationItem } from "sources/catalogs";
import { config, initialState } from "./config";

class OrganizationCatalogItemForm extends FormTemplate {
    sendRequest = (stateData) => {
        if (this.props.dictionary?.propertyName === "ExpenseType") {
            ymEvent("CostItemsDirectoryAcceptButtonClicked");
        }

        return applyOrganizationItem(stateData);
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Сохранить" />;
    };

    renderBodyInner = () => {
        const { config, dictionary } = this.props;
        return (
            <>
                {this.renderField(config.displayName)}
                {dictionary?.propertyName === "EmptyMileageBidReasonType" &&
                    this.renderCheckbox({
                        ...config.options.config.isMileagePaid,
                        value: this.state.options.isMileagePaid,
                        onChange: ({ name, value }) =>
                            this.setValue({ name: "options", value: { ...this.state.options, [name]: value } }),
                    })}
            </>
        );
    };
}

const ConfiguredModal = (props) => {
    const componentInitialState = {};
    Object.keys(config).forEach((key) => {
        componentInitialState[key] = props.data[key] || initialState[key];
    });
    return <OrganizationCatalogItemForm {...props} config={config} initialState={componentInitialState} />;
};

export default ConfiguredModal;
